import { Box, Button, Card, CircularProgress, Divider, Grid, Tooltip, Typography } from "@material-ui/core"
import { isEmpty } from "lodash";
import { useStyles } from "./card-info-confirmar-entrega-motoboy-styles";
import { formatarCPFCNPJ } from "../../../../utils/cpfcnpj-format";
import { toDateString } from "../../../../utils/to-date";
import { pegaHora } from "../../../../utils/pegar-data";
import { PedidoEnderecoModel } from "../../../../model/api/pedidos/pedido-model";
import { useMemo, useState } from "react";
import { CardInfoConfirmarEntregaMotoboyProps } from "./card-info-confirmar-entrega-motoboy-props";
import { CardProdutosConfirmarEntregaMotoboy } from "../card-produtos-confirmar-entrega-motoboy/card-produtos-confirmar-entrega-motoboy";
import { toDecimalString } from "../../../../utils/to-decimal";
import { MapsIcon } from "../../icons/maps-icon";
import { formatarCEP } from "../../../../utils/formatar-cep";
import { phoneMask } from "../../../../utils/phone-mask";
import classNames from "classnames";
import { EnumPagTpMod } from "../../../../model/enums/enum-pag-tpmod";
import { useGetLocalizacaoUsuario } from "../../../../data/api/localizacao/get-localizacao-usuario";
import { useToastSaurus } from "../../../../services/app";

export const CardInfoConfirmarEntregaMotoboy = ({ model }: CardInfoConfirmarEntregaMotoboyProps) => {

    const classes = useStyles();
    const { obterLocalizacao } = useGetLocalizacaoUsuario()
    const [carregandoLocalizacao, setCarregandoLocalizacao] = useState(false)
    const { showToast } = useToastSaurus()

    const retornaEndereco = useMemo(() => {

        const { bairro, municipio, numero, complemento, logradouro, uf, cep, pontoReferencia } = model?.enderecoEntrega ?? new PedidoEnderecoModel()

        if (isEmpty(model?.enderecoEntrega)) {
            return ''
        }

        return `${logradouro ?? ''}, ${numero ?? 0} - ${bairro ?? ''}${municipio ? `, ${municipio}` : ''}${uf ? ` - ${uf}` : ''}${complemento ? `, ${complemento}` : ''}${cep ? ` - ${formatarCEP(cep)}` : ''}${pontoReferencia ? `, ${pontoReferencia}` : ''}`
    }, [model?.enderecoEntrega])

    const getLinkGoogleMaps = async () => {
        try {
            setCarregandoLocalizacao(true)
            const minhaLocalizacao = await obterLocalizacao()
            const origin = `origin=${minhaLocalizacao?.latitude?.toString()},${minhaLocalizacao?.longitude?.toString()}`
            const enderecoEntrega = `${model?.enderecoEntrega?.logradouro},${model?.enderecoEntrega?.numero},${model?.enderecoEntrega?.bairro},${model?.enderecoEntrega?.municipio},${model?.enderecoEntrega?.uf}`

            const link = `https://www.google.com/maps/dir/?api=1&${origin}&destination=${enderecoEntrega}&travelmode=motorcycle`

            return window.open(link, '_blank');
        } catch (err: any) {
            showToast('error', err.message)
        } finally {
            setCarregandoLocalizacao(false)
        }
    }

    return (
        <>
            <Card className={classes.container}>
                <Grid container spacing={2} style={{
                    overflowY: 'auto',
                }}>
                    <Grid item xs={12}>
                        <Grid container style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div>
                                <Typography
                                    variant="h6"
                                    color="textPrimary"
                                >
                                    <Box fontWeight={700}>
                                        {`Pedido N° ${model.codigoPedido}`}
                                    </Box>
                                </Typography>

                            </div>
                            <div>
                                <Typography
                                    variant="body2"
                                    color="primary"
                                >
                                    <Box fontWeight={500}>
                                        {toDateString(new Date(model.dataCriacao))} - {pegaHora(String(model?.dataCriacao))}
                                    </Box>
                                </Typography>
                            </div>
                        </Grid>
                        <Divider variant="fullWidth" className={classes.divider} />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid xs={8}>
                                <Typography
                                    variant="body2"
                                    color='textSecondary'
                                >
                                    Cliente
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                >
                                    <Box fontWeight={600}>
                                        {!isEmpty(model.cliente.razaoSocial) ? model.cliente.razaoSocial : 'Sem Cliente'}
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid xs={4}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    CPF/CNPJ
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                >
                                    {!isEmpty(model.cliente.cpfCnpj) ? formatarCPFCNPJ(model.cliente.cpfCnpj) : '-'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                    Telefone
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="textPrimary"
                                >
                                    {!isEmpty(model.cliente.telefone) ? phoneMask(model.cliente.telefone) : '-'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                        >
                            Endereço
                        </Typography>
                        <Box display="flex" gridGap={8}>
                            <Typography
                                variant="body1"
                                color="textPrimary"
                            >
                                {retornaEndereco.length <= 5 ? 'Sem Endereço' : retornaEndereco}
                            </Typography>
                            <Tooltip arrow title='Mapa'>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={carregandoLocalizacao ? undefined : getLinkGoogleMaps}
                                    style={{
                                        minHeight: '56px',
                                        maxHeight: '56px',
                                        minWidth: '56px',
                                        maxWidth: '56px'
                                    }}
                                >
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        {carregandoLocalizacao
                                            ? <CircularProgress size={20} color="inherit" />
                                            : <MapsIcon tipo="BUTTON_PRIMARY" style={{ marginRight: '0px' }} />}
                                    </span>
                                </Button>
                            </Tooltip>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <CardProdutosConfirmarEntregaMotoboy
                            produtos={model.produtos}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                        >
                            Pagamento
                        </Typography>
                        {model.pagamentos.map(pag => {
                            return (
                                <Box>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography>
                                            {pag.pagamentoDescricao}
                                        </Typography>
                                        <Typography>
                                            <Box className={classNames(classes.cardAReceber, !pag.pagamentoAReceber ? classes.cardAReceberPago : '')}>
                                                {pag.pagamentoAReceber ? 'À Receber' : 'Pago'}
                                            </Box>
                                        </Typography>
                                    </Box>
                                    {pag.tpMod.codigo === EnumPagTpMod.DINHEIRO && (
                                        <Box>
                                            Troco: {' '} <Box component="span" fontWeight={600}>{pag.valorTroco > 0 ? (
                                                <>
                                                    R$ {toDecimalString(pag.valorTroco)}
                                                </>
                                            ) : 'Sem Troco'}</Box>
                                        </Box>
                                    )}
                                </Box>
                            )
                        })}
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                        >
                            Valores
                        </Typography>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>
                                Itens:
                            </Typography>
                            <Typography>
                                <Box component="span" fontWeight={600}>R$ {toDecimalString(model.valorTotalPedido - model.valorTotalFrete)}</Box>
                            </Typography>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>
                                Frete:
                            </Typography>
                            <Typography>
                                <Box component="span" fontWeight={600}>R$ {toDecimalString(model.valorTotalFrete)}</Box>
                            </Typography>
                        </Box>
                        <Box my={.5}>
                            <Divider className={classes.dividerPreco} />
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Typography>
                                Total:
                            </Typography>
                            <Typography>
                                <Box component="span" fontWeight={600}>R$ {toDecimalString(model.valorTotalPedido)}</Box>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Card>
        </>
    )
}